import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by lyxusheng · 偃师市旭晟包装材料有限公司 · 2026"
      links={[
        {
          key: 'lyxusheng',
          title: '偃师市旭晟包装材料有限公司',
          href: 'https://www.lyxsbz.cn/',
          blankTarget: true,
        },
        {
          key: 'ICP备案',
          title: '豫ICP备 2026006340号-1',
          href: 'https://beian.miit.gov.cn/',
          blankTarget: true,
        },
        {
          key: '公安备案',
          title: (
            <>
              <img
                src="/captionIcon.png"
                alt="公安备案图标"
                style={{
                  width: 14,
                  height: 14,
                  marginRight: 4,
                  verticalAlign: 'middle',
                }}
              />
              豫公网安备 41038102000316号
            </>
          ),
          href: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41030302000123',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
